/* eslint-disable react/no-array-index-key */
import React from 'react'

import { Content, Heading } from '../../components/Typography'
import SectionLayout from '../../layouts/SectionLayout/SectionLayout'
import { ContentParser, hasNulls } from '../../utils/helpers'
import { contentRow } from './QualityContentSection.module.css'

const QualityContentSection = ({ slice }) => {
  const qualitContent = ContentParser(slice, 'qualityitem').filter(
    (res) => !hasNulls(Object.values(res)),
  )
  return (
    <SectionLayout>
      {qualitContent.length > 0 &&
        qualitContent.map((item, index) => {
          return (
            <div key={index} className={contentRow}>
              <Heading>{item.qualityheading}</Heading>
              <Content renderContent={item.qualitycontent} />
            </div>
          )
        })}
    </SectionLayout>
  )
}

export default QualityContentSection
